import React from 'react';
import { motion } from 'framer-motion';

interface SurpriseModalProps {
  onClose: () => void;
}

const SurpriseModal: React.FC<SurpriseModalProps> = ({ onClose }) => {
  return (
    <motion.div
      className="modal-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
    >
      <motion.div
        className="modal-content"
        initial={{ scale: 0.5, opacity: 0, y: 50 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.5, opacity: 0, y: 50 }}
        transition={{ type: "spring", damping: 20, stiffness: 300 }}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="close-modal" onClick={onClose}>
          &times;
        </button>
        
        <div className="surprise-content">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            🎉 Surprise for Krisha! 🎉
          </motion.h2>
          
          <div className="surprise-animation">
            <motion.div
              className="dancing-emoji"
              animate={{ 
                scale: [1, 1.2, 1.1, 1.3, 1],
                rotate: [0, 10, -10, 5, 0],
                y: [0, -10, -5, -15, 0]
              }}
              transition={{ 
                duration: 1,
                repeat: Infinity,
                repeatType: "reverse"
              }}
            >
              🦄
            </motion.div>
          </div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
          >
            <p>You are absolutely wonderful, Krisha!</p>
            <p>Keep being your amazing, magical self! ✨</p>
          </motion.div>
          
          {/* Sparkle effects around the modal */}
          {[...Array(8)].map((_, i) => (
            <motion.div
              key={i}
              style={{
                position: 'absolute',
                fontSize: '1.5rem',
                color: '#fbbf24',
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                pointerEvents: 'none'
              }}
              animate={{
                scale: [0, 1, 0],
                rotate: [0, 180, 360],
                opacity: [0, 1, 0]
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                delay: i * 0.2,
                repeatType: "reverse"
              }}
            >
              ✨
            </motion.div>
          ))}
        </div>
      </motion.div>
    </motion.div>
  );
};

export default SurpriseModal;
